<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Nova notícia com IA</span>
      </h1>
      <div>
        <WhiteButton v-if="!loading && article.status != 'pending' && generated" class="px-5 me-2"
          @click="submit('draft')" icon="fa-solid fa-floppy-disk"> Salvar rascunho
        </WhiteButton>
        <PrimaryButton v-if="!loading && generated" class="px-5" @click="submit()" icon="fa-solid fa-paper-plane">
          Enviar</PrimaryButton>
      </div>
    </div>
  </div>

  <div v-if="!loading" class="align p-4 space_title">
    <div class="row">

      <div :class="{ 'col-12 col-lg-8 mb-4': generated, 'col-12': !generated }">
        <div class="card">
          <div class="p-4">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="mt-2 reference_item" v-for="(ref, index) in article.references" :key="index">

                  <div v-if="(index + 1) == article.references.length" class="d-flex">
                    <InputText class="w-100" :label="index == 0 ? 'Fontes da notícia' : ''"
                      v-model="article.references[index]" :error="formErrors.references" />
                    <PrimaryButton id="add_reference" @click="addReference()">+</PrimaryButton>
                  </div>

                  <InputText v-else class="w-100" :label="index == 0 ? 'Fontes da notícia' : ''"
                    v-model="article.references[index]" :error="formErrors.references" />
                </div>
              </div>

              <div class="col-12">
                <PrimaryButton class="w-100" @click="generate()">Gerar notícia</PrimaryButton>
              </div>
            </div>
            </div>
            </div>

            <div v-if="generated" class="card mt-4">
          <div class="p-4">
            <div class="mt-3 row">
              <div class="col-12 mb-3">
                <InputText label="Título" v-model="article.title" :error="formErrors.title" />
              </div>

              <div class="col-12 mb-3">
                <InputText label="Subtitulo" v-model="article.subtitle" :error="formErrors.subtitle" />
              </div>

              <div class="col-12 mb-3">
                <TextArea label="Observações" v-model="article.observations" :error="formErrors.observations"
                  style="height: 90px" />
              </div>

              <div class="col-12 mb-3">
                <div class="counter">
                  {{ textLength }} caracteres
                </div>
                <ArticleEditor v-model="article.content" :error="formErrors.content" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="generated" class="col-12 col-lg-4">
        <div class="card">
          <div class="p-4">
            <div class="row">
              <div class="col-12 mb-3">
                <SelectBox label="Site" id="form_sites" v-model="article.id_site" :error="formErrors.id_site"
                  placeholder="Selecione o site" :items="siteStore.sites" />
              </div>

              <div class="col-12 mb-1">
                <SelectBox label="Categoria" id="category" v-model="article.category" :error="formErrors.category"
                  placeholder="Selecione a categoria" :items="categories" />
              </div>

              <ImageUpload v-model="article.cover_image" :preview="article.cover_image_file_url"
                :error="formErrors.cover_image" />

              <div class="col-12 mb-4">
                <PrimaryButton class="w-100 mt-3" @click="showSearchImageModal = true">Buscar imagem</PrimaryButton>
              </div>

              <div class="col-12 mb-3">
                <InputText label="Créditos da imagem" v-model="article.cover_image_credits"
                  :error="formErrors.cover_image_credits" />
              </div>

              <div class="col-12 mb-3">
                <InputText label="Fonte da imagem" v-model="article.cover_image_url"
                  :error="formErrors.cover_image_url" />
              </div>

              <div class="col-12">
                <InputTag label="Tags" v-model="article.tags" :error="formErrors.cover_image_url" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalDialog width="700px" title="Buscar imagem" v-model="showSearchImageModal">
    <InputText placeholder="Buscar..." v-model="searchImage" @keyup="debouncedSearchImages" />
    <div id="search_images" class="mt-3">
      <div class="row">
        <div class="image col-6 mb-3" v-for="(image, key) in images" :key="key">
          <img :src="image.cover_image" @click="selectImage(image.id, image.cover_image, image.cover_image_credits)" />
          <small class="text-center d-block mt-2">{{ image.cover_image_credits }}</small>
        </div>
      </div>
    </div>
  </ModalDialog>

  <ModalDialog width="400px" title="Selecionar site" v-model="showSiteModal" overflow="inherit" forced="true">
    <SelectBox id="sites" v-model="article.id_site" :error="formErrors.id_site" placeholder="Selecione o site"
      :items="siteStore.sites" />
  </ModalDialog>
</template>

<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import WhiteButton from '@/components/WhiteButton.vue'
import InputText from '@/components/InputText.vue'
import InputTag from '@/components/InputTag.vue'
import RedirectBack from '@/components/RedirectBack.vue'
import SelectBox from '@/components/SelectBox.vue'

import { inject, onBeforeMount, onMounted, ref, watch } from 'vue'
import ImageUpload from '@/components/ImageUpload.vue'
import ArticleEditor from '@/components/ArticleEditor.vue'
import { useArticleStore } from '@/stores/ArticleStore'
import { useSiteStore } from '@/stores/SiteStore'

import { storeToRefs } from 'pinia'
import { useToast, TYPE } from "vue-toastification"
import { useRoute, useRouter } from 'vue-router'
import ModalDialog from '@/components/ModalDialog.vue'
import axios from 'axios'
import TextArea from '@/components/TextArea.vue'
import {errorFormat} from "@/utils/errorFormat";

const toast = useToast();
const loader = inject('$loader');
const loading = ref(false);
const processing = ref(false);
const generated = ref(false);

const router = useRouter();
const route = useRoute();

const articleStore = useArticleStore();
const { article, images } = storeToRefs(articleStore);

const siteStore = useSiteStore();

const categories = ref([]);
const textLength = ref(0);
const showSiteModal = ref(false);

onBeforeMount(async () => {
  article.value = {};
  article.value.references = [null];
  images.value = {};
  siteStore.sites = {};
  loader.show();
  await siteStore.getSitesList();
  loader.hide();
});

onMounted(async () => {
  const id = route.params.id;
  if (route.name == 'articleEdit') {
    loader.show();
    loading.value = true;

    await articleStore.getArticle(id);

    textLength.value = extractText(article.value.content).length;

    loader.hide();
    loading.value = false;
  } else {
    showSiteModal.value = true;
  }
});

const extractText = (htmlString) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || "";
};

watch(() => article.value.content, (newValue) => {
  if (newValue) {
    textLength.value = extractText(newValue).length;
  }
}, { immediate: true });

watch(() => article.value.id_site, (value) => {

  if (value && siteStore.sites.length) {
    showSiteModal.value = false;
    const selectedSite = siteStore.sites.find(site => site.id === value);
    if (selectedSite && selectedSite.categories) {
      categories.value = selectedSite.categories;
    } else {
      categories.value = [];
    }
  } else {
    categories.value = [];
  }
}, { immediate: true });

const formErrors = ref({});


const generate = async () => {
  if (processing.value == true) {
    return;
  }

  let params = {
    references: Array.isArray(article.value.references) && article.value.references.every(item => item === '') ? null : article.value.references,
  };

  loader.show();
  formErrors.value = {};
  processing.value = true;

  const formGenerateResult = await articleStore.generateArticle(params);
  if (formGenerateResult.success) {
    article.value.title = formGenerateResult.article.title;
    article.value.subtitle = formGenerateResult.article.subtitle;
    article.value.content = formGenerateResult.article.content;
    generated.value = true;
  }else {
    toast('Ocorreu um erro, tente novamente', { type: TYPE.ERROR, timeout: 6000 });
  }

  processing.value = false;
  loader.hide();
};


const submit = async (draft = false) => {
  if (processing.value == true) {
    return;
  }

  let params = {
    title: article.value.title,
    subtitle: article.value.subtitle,
    references: Array.isArray(article.value.references) && article.value.references.every(item => item === '') ? null : article.value.references,
    content: article.value.content,
    id_site: article.value.id_site,
    category: article.value.category,
    tags: article.value.tags,
    cover_image: article.value.cover_image,
    cover_image_credits: article.value.cover_image_credits,
    cover_image_url: article.value.cover_image_url,
    id_selected_cover_image: article.value.id_selected_cover_image,
    checked: true,
    observations: article.value.observations,
  };

  if (draft) {
    params.draft = true;
  }

  loader.show();
  formErrors.value = {};
  processing.value = true;

    const formResult = await articleStore.addArticle(params);
    if (formResult.success) {
      if (params.draft) {
        toast('Rascunho salvo', { type: TYPE.SUCCESS, timeout: 6000 });
      } else {
        toast('Notícia enviada', { type: TYPE.SUCCESS, timeout: 6000 });
        router.push({ name: 'articles' });
      }
    }
    else {
      formErrors.value = errorFormat(formResult.errors);

      if (formResult.message) {
        toast(formResult.message, { type: TYPE.ERROR, timeout: 6000 });
      }
    }

  processing.value = false;
  loader.hide();
};

const addReference = () => {
  if (article.value.references.length == 3) {
    return;
  }
  article.value.references.push('');
};

const showSearchImageModal = ref(false);
let cancelTokenSource = null;
let searchImage = ref(null);

async function searchImages(event) {

  loader.show();
  articleStore.filter.page = parseInt(route.query.page);
  window.scrollTo(0, 0);

  if (cancelTokenSource) {
    cancelTokenSource.cancel('Cancelado devido a nova busca');
  }

  cancelTokenSource = axios.CancelToken.source();

  let params = {
    search: event.target.value,
  }

  let result = await articleStore.searchImages(params, cancelTokenSource);
  if (result.success) {
    loader.hide();
  }
}

const debouncedSearchImages = debounce(searchImages, 300);

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const selectImage = (id, cover_image, cover_image_credits) => {
  article.value.id_selected_cover_image = id;
  article.value.cover_image = null;
  article.value.cover_image_file_url = cover_image;
  article.value.cover_image_credits = cover_image_credits;
  article.value.cover_image_url = null;

  showSearchImageModal.value = false;
};
</script>

<style scoped>
#add_reference {
  height: 43px;
  margin-left: 10px;
}

.counter {
  display: inline-block;
  background-color: #583a8e;
  padding: 2px 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  color: #fff;
}

#search_images .image img {
  width: 100%;
  cursor: pointer;
}

#search_images .image:hover {
  opacity: 0.5;
}

#search_images {
  max-height: 510px;
  overflow-y: auto;
  overflow-x: hidden;
}

#add_reference {
  margin-top: 4px;
}

.reference_item:first-child #add_reference {
  margin-top: 25px;
}

.alert {
  background-color: #f6aa10;
}

#article_check {
  border: 2px #dda40e solid;
}

#article_check ul {
  padding: 0;
  margin-bottom: 0;
}

#article_check ul li {
  background-color: #ececec;
  padding: 15px;
  border-radius: 6px;
  list-style: none;
  border: 0;
  font-weight: 500;
}
</style>